module.exports = __webpack_public_path__ + "static/media/curIndTesis.4ac8887a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curIndTesis.png
// module id = 971
// module chunks = 0